import { NavLink, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, Building2, Target, Inbox, MessagesSquare, Trophy, Settings as SettingsIcon,
  LogOut, ShieldCheck,
} from "lucide-react";
import { clearToken } from "@/api";

const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/targets", label: "Targets", icon: Target, testid: "nav-targets" },
  { to: "/prospects", label: "Prospects", icon: Building2, testid: "nav-prospects" },
  { to: "/opportunities", label: "Opportunities", icon: ShieldCheck, testid: "nav-opportunities" },
  { to: "/marketplace", label: "Marketplace", icon: Inbox, testid: "nav-marketplace" },
  { to: "/conversations", label: "Conversations", icon: MessagesSquare, testid: "nav-conversations" },
  { to: "/outcomes", label: "Outcomes", icon: Trophy, testid: "nav-outcomes" },
  { to: "/settings", label: "Settings", icon: SettingsIcon, testid: "nav-settings" },
];

export default function Layout({ children }) {
  const navigate = useNavigate();
  const logout = () => {
    clearToken();
    navigate("/login");
  };
  return (
    <div className="flex min-h-screen bg-[#0B0F17]">
      <aside className="w-56 shrink-0 border-r border-slate-800 bg-[#0D1320] flex flex-col" data-testid="sidebar">
        <div className="px-4 py-5 border-b border-slate-800">
          <div className="font-heading text-lg font-semibold tracking-tight text-slate-100">KNKT Outreach</div>
          <div className="font-mono text-[10px] uppercase tracking-widest text-slate-500 mt-1">Operator Surface v1.1</div>
        </div>
        <nav className="flex-1 py-3 px-2 space-y-0.5">
          {NAV.map(({ to, label, icon: Icon, testid }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              data-testid={testid}
              className={({ isActive }) =>
                `flex items-center gap-2.5 px-3 py-2 rounded-md text-sm transition-colors duration-150 ${
                  isActive
                    ? "bg-sky-950/60 text-sky-300 border border-sky-900/60"
                    : "text-slate-400 hover:text-slate-200 hover:bg-slate-800/50 border border-transparent"
                }`
              }
            >
              <Icon size={15} strokeWidth={1.8} />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="px-4 py-4 border-t border-slate-800 space-y-3">
          <div className="flex items-center gap-2" data-testid="atlas-governance-badge">
            <ShieldCheck size={14} className="text-emerald-400" />
            <span className="font-mono text-[10px] uppercase tracking-widest text-emerald-400/90">ATLAS contract v1</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-xs text-slate-500">Operator: <span className="text-slate-300">Tamara</span></span>
            <button
              onClick={logout}
              data-testid="logout-btn"
              className="text-slate-500 hover:text-slate-200 transition-colors"
              title="Sign out"
            >
              <LogOut size={14} />
            </button>
          </div>
        </div>
      </aside>
      <main className="flex-1 min-w-0 p-4 sm:p-6 lg:p-8">{children}</main>
    </div>
  );
}
